var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79.625,
    height: 81.375,
    viewBox: "0 0 79.625 81.375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.81 0C50.37 0 60.49 4.28 67.96 11.91C75.43 19.54 79.62 29.89 79.62 40.68C79.62 51.47 75.43 61.82 67.96 69.45C60.49 77.08 50.37 81.37 39.81 81.37C29.25 81.37 19.12 77.08 11.66 69.45C4.19 61.82 0 51.47 0 40.68C0 29.89 4.19 19.54 11.66 11.91C19.12 4.28 29.25 0 39.81 0ZM34.85 48.71L26 39.67C25.69 39.34 25.31 39.08 24.9 38.91C24.48 38.73 24.04 38.64 23.59 38.64C23.14 38.64 22.7 38.73 22.28 38.91C21.87 39.08 21.49 39.34 21.18 39.67C20.53 40.32 20.18 41.21 20.18 42.13C20.18 43.06 20.53 43.95 21.18 44.6L32.44 56.11C32.75 56.43 33.13 56.69 33.54 56.87C33.96 57.05 34.4 57.14 34.85 57.14C35.3 57.14 35.74 57.05 36.16 56.87C36.57 56.69 36.95 56.43 37.27 56.11L60.58 32.27C60.91 31.95 61.16 31.56 61.34 31.14C61.51 30.72 61.6 30.26 61.6 29.8C61.61 29.34 61.52 28.88 61.35 28.46C61.18 28.03 60.92 27.65 60.61 27.32C60.29 26.99 59.91 26.74 59.49 26.56C59.08 26.38 58.63 26.3 58.18 26.3C57.73 26.3 57.28 26.39 56.87 26.57C56.45 26.75 56.08 27.01 55.76 27.34L34.85 48.71Z",
    fill: "#7252DC",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.ba042f30f94206136126c9e50499c8c4.svg";
export { ForwardRef as ReactComponent };